// extracted by mini-css-extract-plugin
export var autocompleteDropdownContainer = "AutoComplete-module--autocompleteDropdownContainer--f3082";
export var input = "AutoComplete-module--input--bc3a3";
export var suggestion = "AutoComplete-module--suggestion--67abd";
export var wrapper = "AutoComplete-module--wrapper--1bfd4";